import React, { useState } from "react";
import "../../css/Manage.css";
import "../../css/accomodation/ManageAccomodationRoomAdd.css";
import { toast } from "react-toastify";
import { nullCheck } from "../../utils/check";
import RoomApi from "../../api/roomApi";

const ManageAccomodationRoomAdd = (props) => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");

  // 이미지 업로드
  const inputImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        setImage(file);
        setImagePreview(e.target.result);
      };
    }
    e.target.value = "";
  };

  const deleteImage = () => {
    setImage(null);
    setImagePreview("");
  };

  // 저장
  const save = async () => {
    try {
      if (nullCheck(name)) {
        toast("객실명을 입력해주세요.");
        return;
      }
      if (nullCheck(price)) {
        toast("가격을 입력해주세요.");
        return;
      }
      if (!image) {
        toast("이미지를 등록해주세요.");
        return;
      }

      const requestDto = new FormData();
      requestDto.append("accomodationId", props.accomodationId);
      requestDto.append("name", name);
      requestDto.append("price", price);
      requestDto.append("image", image);

      await RoomApi.Post(requestDto);
      toast("저장되었습니다.");
      if (props.onRoomAdded) {
        props.onRoomAdded();
      }
      setName("");
      setPrice("");
      setImage(null);
      setImagePreview("");
      props.setAddRoomPopupFlag(false);
    } catch (error) {
      console.log(error);
      if (error.response?.status === 413) {
        toast(`이미지 용량을 초과하였습니다.`);
      } else {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    }
  };

  return props.openFlag ? (
    <div>
      <div className="accomodation-room-add-container">
        <div className="accomodation-room-add-popup" ref={props.searchRef}>
          <span>새로운 객실 추가하기</span>
          <div className="Manage-input-container manage-input-container-room-popup">
            <p className="Manage-input-title">객실명*</p>
            <input
              type="text"
              className="Manage-input-textarea"
              placeholder="객실명"
              style={{ width: "366px" }}
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
          <div className="Manage-input-container manage-input-container-room-popup">
            <p className="Manage-input-title">가격*</p>
            <input
              type="number"
              className="Manage-input-textarea"
              style={{ width: "366px" }}
              placeholder="가격"
              value={price}
              onChange={(e) => {
                setPrice(e.target.value);
              }}
            />
          </div>
          <div className="Manage-input-container manage-input-container-room-popup">
            <p className="Manage-input-title">이미지*</p>
            <div className="room-popup-img-container">
              <label htmlFor="room-img-input">
                <img src="\img\file-upload-plus.svg" />
                <span>파일 등록</span>
              </label>
              <input
                id="room-img-input"
                className="Manage-input-textarea"
                type="file"
                accept="image/*"
                required
                onChange={(e) => {
                  inputImage(e);
                }}
              />
              {imagePreview ? (
                <div className="room-popup-img-preview">
                  <img className="uploaded-img" src={imagePreview} />
                  <img
                    className="room-img-cancel cursorPointer"
                    src="\img\image-cancel.svg"
                    onClick={(e) => deleteImage()}
                  />
                </div>
              ) : null}
            </div>
          </div>
          <div className="save-accomodation-room-add-popup">
            <a
              onClick={(e) => {
                setName("");
                setPrice("");
                setImage(null);
                setImagePreview("");
                props.setAddRoomPopupFlag(false);
              }}
            >
              닫기
            </a>
            <a
              onClick={(e) => {
                save();
              }}
            >
              추가하기
            </a>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ManageAccomodationRoomAdd;
